export const useStoreEvent = defineStore('StoreEvent', {
    state: () => ({
        event: null,
        videos: null,
        error: null,
    }),
    actions: {
        async getEvent(eventSlug) {
            this.error = null;
            this.event = null;
            let responses = await Promise.all([useEntityEvent().get(eventSlug), this.getVideos(eventSlug)]);
            this.event = responses[0]?.event;
            this.error = responses[0]?.error;
        },
        async getVideos(eventSlug) {
            this.error = null;
            const filter = {
                paginate: {
                    auto: false,
                },
                fields: {
                    event_slug: eventSlug,
                },
                order: [
                    {field: 'video_date_taken', asc: false},
                    {field: 'video_division', asc: true},
                    {field: 'video_format', asc: true},
                    {field: 'video_placing', asc: true},
                    {field: 'id_dancer', asc: false},
                    {field: 'video_title', asc: true},
                ],
            };
            ({videos: this.videos} = await useQueryVideos().get(filter));
        },
    },
});
